import Vue from 'vue/dist/vue.min.js';
import { dayjs } from '../components/dayjs-localized';
import cmgSimulator from './mixins/cmgSimulator';
import cmgCalculations from './mixins/cmg_calculations';
// import * as noUiSlider from 'nouislider/dist/nouislider.min';

// Vue.config.devtools = true;

export function createCmgSimulatorAssmat() {
  return new Vue({
    el: '#paje-simulator',
    mixins: [cmgSimulator, cmgCalculations],
    data() {
      return {
        gross_hourly_wage: '4.00',
        grossHourlyWageInput: '4,00',
        maintenanceAllowanceMinimum: 2.65,
        mealDailyAllowance: '0,00',
        minimumGrossHourlyWage: 0,
        maximumGrossHourlyWage: 15.00,
        ie: '3,20',
        taxLimit: 1750,
        transportDailyAllowance: '0,00',
        singleParentChildAgeOptions: [
          { value: 'six-or-more', text: '12 ans ou moins' },
          { value: 'greater-than-twelve', text: 'Plus de 12 ans' },
        ],
        coupleChildAgeOption: [{
          value: 'six-or-more',
          text: '6 ans ou plus',
        }],
      };
    },
    computed: {
      handicapToggleInfos: function() {
        return this.handicap_toggle
          ? '<p>Le montant est majoré de 30% quand votre enfant est en situation d\'handicap.</p>'
          : '';
      },
      monthlyOvertimeFloat() {
        return this.isMonth
          ? parseFloat(this.monthly_overtime.replace(',', '.'))
          : (
              this.weeklyOvertimeFloat / this.weekly_worked_days_f * this.monthly_worked_days_f
            );
      },
      weeklyOvertimeFloat() {
        return this.has_overtime ? this.weekly_hours_f - 45 : 0;
      },
      maintenanceAllowanceFloat() {
        return parseFloat(this.ie.replace(',', '.'));
      },
      maintenanceAllowanceMonthly() {
        return this.maintenanceAllowanceFloat * this.allowanceDays;
      },
      maintenanceAllowanceHourly() {
        return this.maintenanceAllowanceMonthly / this.monthly_hours_f;
      },
      maintenanceAllowanceMonthlyDetaxLimit() {
        return Math.min(this.maintenanceAllowanceFloat, this.maintenanceAllowanceMinimum) * this.allowanceDays;
      },
      allowanceDays() {
        return (this.is_full_year ? this.monthly_worked_days_f * this.yearlyWorkedWeeks / 52 : this.monthly_worked_days_f);
      },
      netHourlyWage() {
        return this.gross_hourly_wage_f * this.net_ratio_classic;
      },
      grossMonthlyWageRegular() {
        return this.regular_hours * this.gross_hourly_wage_f;
      },
      grossMonthlyOvertimeWage() {
        return this.has_overtime ? this.monthlyOvertimeFloat * this.gross_hourly_wage_f : 0;
      },
      grossMonthlyOvertimeWagePremium() {
        return this.has_overtime
          ? this.monthlyOvertimeFloat * this.gross_hourly_wage_f * this.increase_overtime_i / 100
          : 0;
      },
      isCalculable() {
        if (this.month_week === 'month') {
          if (!this.is_monthly_hours || !this.is_monthly_worked_days) return false;
          if (this.has_overtime && !this.is_monthly_overtime) return false;
          if (this.has_overtime && (this.monthlyOvertimeFloat > this.monthly_hours_f)) return false;
          if (!this.isWeeklyHours || !this.is_weekly_worked_days || !this.isYearlyWeeks) return false;
        } else if (this.month_week === 'week') {
          if (!this.isWeeklyHours || !this.is_weekly_worked_days || !this.isYearlyWeeks) return false;
        }

        // aucune idée de pourquoi mais si mis en condition supplémentaire dans le case, renvoie
        // systématiquement false pour les autres conditions
        if (this.month_week === 'other') return false;

        return this.isMaintenanceAllowanceAllowed;
      },
      isWeeklyHours() {
        return this.weekly_hours !== '' && this.weekly_hours_f >= 0 && this.weekly_hours_f <= 75;
      },
      isYearlyWeeks() {
        return this.yearly_weeks !== '' &&
            (this.yearly_weeks_f === 52 ||
                (this.yearly_weeks_f >= 0 &&
                    (this.yearly_weeks_f <= 46 ||
                        (this.contract_ends_before_one_year && this.yearly_weeks_f < 52)
                    )
                )
            );
      },
      isMaintenanceAllowanceAllowed() {
        return this.ie !== '' && this.maintenanceAllowanceFloat >= 0 && this.maintenanceAllowanceFloat <= 50;
      },
      netVacationsMonthly() {
        return this.is_full_year ? 0 : this.net_partial_year_vacations_monthly;
      },
      grossVacationsMonthly() {
        return this.is_full_year ? 0 : this.gross_partial_year_vacations_monthly;
      },
      total_amount() {
        return this.grossTotal +
            this.social_contributions_employer +
            this.maintenanceAllowanceMonthly +
            this.transportAllowanceMonthly +
            this.mealAllowanceMonthly;
      },
      net_paid_total() {
        // Attention on a retiré le+ this.netVacationsMonthly   pour les contrats en année incomplète
        return this.net_mensualization +
            this.net_monthy_overtime_increase +
            this.maintenanceAllowanceMonthly +
            this.transportAllowanceMonthly +
            this.mealAllowanceMonthly;
      },
      grossTotal() {
        // Attention on a retiré le + this.grossVacationsMonthly pour les contrats en année incomplète
        return this.gross_mensualization + this.grossMonthlyOvertimeWagePremium;
      },
      socialContributionsCredit() {
        return this.cmgUnavailable ? 0 : (this.social_contributions_employee + this.social_contributions_employer);
      },
      /***
       * The social contribution needs to be capped by max help
       * The ratio below is one that has been reversed engineered through the urssaf simulator
       * Warning: The calculations below are not exact because we should not take into account the maintenance
       * and the meal allowance
       */
      socialContributionMaxHelpRatio() {
        const realHourlyRateNet = Math.ceil(this.realHourlyRateNet * 100) / 100;
        return realHourlyRateNet > this.maxNetHelp ? Math.ceil(this.maxNetHelp / realHourlyRateNet * 100) / 100 : 1;

        // const totalWageNet = (this.net_mensualization_classic + this.net_monthy_overtime_increase) / this.monthly_hours_f;
        // const maxRate = this.maxNetHelp - this.mealAllowanceHourly - this.maintenanceAllowanceHourly;
        // return Math.min(maxRate, totalWageNet) / totalWageNet;
      },
      socialContributionsCreditNewCMG() {
        return this.newCMGNotAvailable ? 0 : (this.social_contributions_employee + this.social_contributions_employer) * this.socialContributionMaxHelpRatio;
      },
      transportDailyAllowanceParsed() {
        return parseFloat(this.transportDailyAllowance.replace(',', '.'));
      },
      mealDailyAllowanceParsed() {
        return parseFloat(this.mealDailyAllowance.replace(',', '.'));
      },

      /***
       * As the allowance is on a daily basis we will calculate it for the month as we
       * may not have the exact of hours worked per day depending on the toggle week / month
       * */
      transportAllowanceMonthly() {
        return this.transportDailyAllowanceParsed * this.allowanceDays;
      },
      mealAllowanceMonthly() {
        return this.mealDailyAllowanceParsed * this.allowanceDays;
      },
      mealAllowanceHourly() {
        return this.mealAllowanceMonthly / this.monthly_hours_f;
      },
    },
    methods: {
      cmgAmount(rangeIndex) {
        let amount;
        if (this.child_age_option === '6' || this.cmgUnavailable) {
          amount = 0;
        } else {
          // if the parent works partially we must divide the cmg amount
          const divideMaxAmount = this.cmgAidToggle === 'partial' ? 2 : 1;
          const maximumAmount = this.maximum_amount(rangeIndex) / divideMaxAmount;

          // Attention on a retiré le this.netVacationsMonthly pour les contrats en année incomplète
          const perceivableAmount = ((
            this.net_mensualization +
              this.net_monthy_overtime_increase +
              this.maintenanceAllowanceMonthly
          ) * 0.85) / divideMaxAmount;

          amount = Math.min(maximumAmount, perceivableAmount);
        }
        return amount;
      },
      injectAgeOptions(parentSituation) {
        const select = document.querySelector('.cmg-simulator__min-child-age');
        if (!select) return;

        // Prevent duplicate injection
        this.removeInjectedAgeOptions();

        const ageOptions = parentSituation === 'single' ? this.singleParentChildAgeOptions : this.coupleChildAgeOption;

        ageOptions.forEach(opt => {
          const option = document.createElement('option');
          option.value = opt.value;
          option.text = opt.text;
          select.appendChild(option);
        });

        // reset options to first option
        this.youngestChildAge = 'less-than-six';
      },
      removeInjectedAgeOptions() {
        const select = document.querySelector('.cmg-simulator__min-child-age');
        if (!select) return;

        const options = Array.from(select.options);
        options.forEach(opt => {
          if (['six-or-more', 'greater-than-twelve'].includes(opt.value)) {
            select.removeChild(opt);
          }
        });
      },
      remainingAmount(i) {
        return Math.max((this.total_amount - this.socialContributionsCredit - this.cmgAmount(i) - this.other_aid_f), 0);
      },
      taxesCredit(i) {
        return this.child_age_option.toString() === '6'
          ? 0
          : Math.min(Math.max(
            (
              this.grossTotal +
                this.social_contributions_employer +
                Math.min(this.maintenanceAllowanceMonthlyDetaxLimit, this.maintenanceAllowanceMonthly) -
                this.socialContributionsCredit -
                this.cmgAmount(i) - this.other_aid_f) * 12 / 2, 0), this.taxLimit
          );
      },
      weekFromMonth() {
        if (this.is_monthly_overtime) {
          let weeklyOvertime = 0;
          this.weekly_hours = '40';

          if (this.is_weekly_worked_days && this.is_monthly_worked_days) {
            weeklyOvertime = ((this.monthlyOvertimeFloat / this.monthly_worked_days_f) * this.weekly_worked_days_f);
          }

          if (this.is_monthly_hours && this.is_weekly_worked_days && this.is_monthly_worked_days) {
            const normalWorkingHours = this.monthly_hours_f - this.monthlyOvertimeFloat;
            this.weekly_hours = this.toFloatForDisplay(
              ((normalWorkingHours / this.monthly_worked_days_f * this.weekly_worked_days_f) + weeklyOvertime), 2);
          }
        } else {
          if (this.is_monthly_hours && this.is_weekly_worked_days && this.is_monthly_worked_days) {
            this.weekly_hours = this.toFloatForDisplay((this.monthly_hours_f * 12 / this.yearly_weeks_f), 2);
            this.weekly_worked_days = this.toFloatForDisplay(this.monthly_worked_days_f * 12 / this.yearly_weeks_f, 2);
          } else {
            this.weekly_hours = '40';
          }
        }
      },
      isSocialContributionRelevant(name) {
        const contribution = this.social_contributions[name];

        if (contribution.care_type !== 'assmat' && contribution.care_type !== '') return false;
        if (typeof contribution.alsace_moselle_specific !== 'undefined' && !this.alsace_moselle) return false;
        if (typeof contribution.start_date !== 'undefined' && dayjs() < dayjs(contribution.start_date)) return false;
        if (typeof contribution.end_date !== 'undefined' && dayjs() > dayjs(contribution.end_date)) return false;

        return true;
      },
      checkErrors() {
        $('.wrapper_input.simulator_weekly_worked_days .input-group')
          .toggleClass('is-invalid', !this.is_weekly_worked_days);
        $('.wrapper_input.simulator_weekly_hours .input-group').toggleClass('is-invalid', !this.isWeeklyHours);
        $('.wrapper_input.simulator_yearly_weeks .input-group').toggleClass('is-invalid', !this.isYearlyWeeks);
        $('.wrapper_input.simulator_monthly_worked_days .input-group')
          .toggleClass('is-invalid', !this.is_monthly_worked_days);
        $('.wrapper_input.simulator_monthly_hours .input-group').toggleClass('is-invalid', !this.is_monthly_hours);
        $('.wrapper_input.simulator_daily_maintenance_allowance .input-group').toggleClass('is-invalid', !this.isMaintenanceAllowanceAllowed);
        $('.wrapper_input.simulator_monthly_overtime .input-group')
          .toggleClass('is-invalid', !this.is_monthly_overtime);
      },
      updateSliderColor(element, value, cmgUnavailable) {
        const tooltip = element.querySelector('.noUi-tooltip');
        const sliderGauge = element.querySelector('.noUi-connect');

        if (cmgUnavailable) {
          tooltip.classList.add('with-error');
          if (!tooltip.querySelector('.cmg-maxerror')) {
            tooltip.innerHTML += '' +
                '<div class="cmg-maxerror text-danger">' +
                '<span class="red dotted" data-scroll-to="employer-cost">Alerte</span>' +
                '</div>';
          }
          sliderGauge.style.background = 'red';
        } else {
          tooltip.classList.remove('with-error');
          sliderGauge.style.background = '#2DA3ED';
        }
      },
      createWageSlider() {
        const that = this;

        // Non-linear slider : on fait en sorte que le taux horaire puisse avoir un maximum très haut, sans impacter l'ensemble du slider
        // eslint-disable-next-line no-undef
        this.slider = noUiSlider.create(document.getElementById('paje-simulator-slider'), {
          start: this.gross_hourly_wage_f,
          tooltips: [true],
          connect: 'lower',
          range: {
            min: this.minimumGrossHourlyWage,
            '75%': this.minimumGrossHourlyWage * 2,
            max: this.maximumGrossHourlyWage,
          },
          step: 0.01,
          format: {
            to: function(value) {
              return '<b>' + that.to_money(value) +
                  '</b><br/><span class=\'font--xs\'>(' + that.to_money(value * that.net_ratio_classic) +
                  ' net)</span>';
            },
            from: function(value) {
              return value;
            },
          },
        });

        this.slider.on('update', function(label, key, value) {
          that.gross_hourly_wage = that.toFloatForDisplay(value[0], 2);
          if (!that.hourlyWageSetFromInput) {
            that.grossHourlyWageInput = that.gross_hourly_wage;
          }
          // that.updateSliderColor(document.getElementById('hourly-rate-container'), value[key], that.cmgUnavailable);
        });
      },
    },
    mounted() {
      this.$nextTick(function() {
        this.toggleMW();
        this.monthFromWeek();
        this.createWageSlider();
      });
    },
    watch: {
      situation(newVal) {
        this.injectAgeOptions(newVal);
      },
      weekly_worked_days: function() {
        this.monthFromWeek();
        this.checkErrors();
      },
      weekly_hours: function() {
        this.monthFromWeek();

        this.has_overtime = this.weekly_hours_f > 45;

        this.checkErrors();
      },
      ie: function() {
        this.checkErrors();
      },
      has_overtime: function() {
        const $plannedOvertimeToggle = $('.toggle.planned_overtime');
        $plannedOvertimeToggle.prop('checked', this.has_overtime);
        $plannedOvertimeToggle.change();
        const that = this;
        setTimeout(function() {
          that.checkErrors();
        });
      },
    },
  });
}
